import { createSelector } from 'reselect';
import _get from 'lodash/get';
import { selectFeatureFlags } from './ContextSelector';

const bopisMessageSelector = (state) => state.bopisMessageData;

const getBOPISMessage = createSelector(
    [selectFeatureFlags, bopisMessageSelector],
    (featureFlags, bopisMessageData) => {
        const { enableCMFragments } = featureFlags;

        if (bopisMessageData?.fallback) {
            return _get(bopisMessageData?.data, 'content.components[0].content.html');
        }
        return enableCMFragments
            ? _get(bopisMessageData?.data, 'page.grid.placements[0].items[0].html')
            : _get(bopisMessageData?.data, 'content.components[0].content.html');
    }
);

export default getBOPISMessage;
